import { defineStore } from "pinia";

export const useDashboardStore = defineStore("dashboard", {
  state: () => ({
    stores: [],
    loadStores: false,
    deals: [],
    loadDeals: false,
    mfgs: [],
    loadMfg: false,
    rank_info: {},
    loadRankInfo: false,
    user_info: {},
    loadUserInfo: false,
    swagProduct: [],
    loadSwagProduct: false,
  }),
  getters: {
    storeList: (state) => state.stores,
    mfgList: (state) => state.mfgs,
  },
  actions: {
    async getMyStores(param = { enforce_age_restrictions: 1 }) {
      if (Object.keys(param).length == 1) {
        this.resetStore();
      } else if (param && param.page && param.page == 1) {
        this.resetStore();
      }
      try {
        let response = await this.$request.get(
          this.apiEndpoints.MY_STORE + new URLSearchParams(param).toString()
        );
        if (response.data) {
          if (Object.keys(param).length == 1) {
            this.resetStore();
          } else if (param && param.page && param.page == 1) {
            this.resetStore();
          }
          Array.prototype.push.apply(
            this.stores,
            response.data.items ? response.data.items : []
          );
          // this.stores = response.data.items;
          this.loadStores = true;
        }
        return response.data;
      } catch (error) {
        // console.log("FromAPI:-" + error);
      }
    },
    resetStore() {
      this.stores = [];
      this.loadStores = false;
    },
    async getMyDeals() {
      try {
        let response = await this.$request.get(this.apiEndpoints.MY_DEALS);
        if (response.data) {
          this.deals = response.data.items;
          this.loadDeals = true;
        }
      } catch (error) {}
    },
    async getMyMfg() {
      try {
        let response = await this.$request.post(this.apiEndpoints.MY_MFG, {
          enforce_age_restrictions: 1,
        });
        if (response.data) {
          this.mfgs = response.data.items;
          this.loadMfg = true;
        }
      } catch (error) {}
    },
    async getTopLeaderboard() {
      try {
        let response = await this.$request.get(
          this.apiEndpoints.TOP_LEADERBOARD + "?limit=3"
        );
        if (response.data) {
          this.rank_info = response.data.item;
          this.loadRankInfo = true;
        }
      } catch (error) {}
    },
    async joinTeam(customerid, storeid) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.JOIN_TEAM(customerid),
          {
            store_id: storeid,
            enforce_age_restrictions: 1,
          }
        );
        return response.data;
      } catch (error) {
        return error;
      }
    },
    async addLoyaltyCard(cardNumber) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.ADD_LOYALTY_CARD,
          {
            card_number: cardNumber,
          }
        );
        return response.data;
      } catch (error) {
        return error;
      }
    },
    async getSwagShopProductForDashboard(params) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.SWAGSHOP_STORE_PRODUCTS,
          {
            sort_by: "name",
            sort_direction: "asc",
            per_page: 6,
            enforce_age_restrictions: 1,
            ...params,
          }
        );
        if (response.data) {
          this.loadSwagProduct = true;
          if (response.data.items) {
            this.swagProduct = response.data.items;
            this.swagProduct.sort((a, b) => {
              let fa = a.name.toLowerCase(),
                fb = b.name.toLowerCase();
              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            });
          }
        }
      } catch (error) {}
    },
    async getCouponsDetails(param) {
      try {
        let response = await this.$request.post(
          this.apiEndpoints.COUPON_DETAILS(param.coupon_id),
          param
        );
        return response?.data;
      } catch (error) {
        return {
          status: false,
        };
      }
    },
  },
});
